/* * 本页面为企业注册审核页面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
        >
          <template slot-scope="slotForms">
            <el-form-item label="企业名称" prop="forms.comparyName">
              <el-input
                disabled
                v-model="slotForms.forms.comparyName"
                placeholder="企业名称"
                clearable
              ></el-input>
            </el-form-item>
            <!--<el-form-item label="企业注册地址" prop="forms.regisAddress">-->
            <!--<el-input-->
            <!--disabled-->
            <!--v-model="slotForms.forms.regisAddress"-->
            <!--placeholder="企业注册地址"-->
            <!--clearable-->
            <!--&gt;</el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item prop="forms.provinceId" label="所属省">-->
            <!--<el-select-->
            <!--disabled-->
            <!--v-model="slotForms.forms.provinceId"-->
            <!--placeholder="所属省"-->
            <!--@change="provinceChange"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in provinceList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item prop="forms.cityId" label="所属市">-->
            <!--<el-select-->
            <!--disabled-->
            <!--v-model="slotForms.forms.cityId"-->
            <!--placeholder="所属市"-->
            <!--@change="cityChange"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in cityList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item prop="forms.countyName" label="所属区县">-->
            <!--<el-select-->
            <!--disabled-->
            <!--v-model="slotForms.forms.countyName"-->
            <!--placeholder="所属区县"-->
            <!--clearable-->
            <!--filterable-->
            <!--&gt;-->
            <!--<el-option-->
            <!--v-for="item in countyList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.name"-->
            <!--&gt;</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <div class="group_form">
              <el-form-item
                label="企业所属地"
                prop="forms.regisAreas"
                class="address"
              >
                <e6-city
                  ref="e6City"
                  :format="$GLOBAL_CONFIG.e6City.format"
                  :placeholder="slotForms.forms.regisAreas"
                  :label="slotForms.forms.regisAreas"
                  class="e6-city"
                  @selected="citysSelect"
                ></e6-city>
              </el-form-item>

              <!--<el-form-item-->
              <!--label="注册地址"-->
              <!--prop="forms.regisArea"-->
              <!--class="address"-->
              <!--&gt;-->
              <!--<e6-city-->
              <!--ref="e6City"-->
              <!--:format="$GLOBAL_CONFIG.e6City.format"-->
              <!--:placeholder="$GLOBAL_CONFIG.e6City.placeholder"-->
              <!--:label="slotForms.forms.regisArea"-->
              <!--class="e6-city"-->
              <!--@selected="citySelect"-->
              <!--:fixed-bin="$GLOBAL_CONFIG.e6City.bin"-->
              <!--&gt;</e6-city>-->
              <!--</el-form-item>-->
              <el-form-item prop="forms.regisAddress">
                <el-button
                  @click="selectAddress()"
                  :class="slotForms.forms.regisAddress ? '' : 'show_tips'"
                >
                  <span :title="regisAddress" class="register-txt">{{
                    slotForms.forms.regisAddress
                  }}</span>
                  <i class="e6-icon-map_line"></i>
                </el-button>
              </el-form-item>
            </div>

            <el-form-item label="角色属性" prop="forms.userAppTypeList">
              <el-checkbox-group
                v-model="slotForms.forms.userAppTypeList"
                disabled
              >
                <el-checkbox :label="0">企业</el-checkbox>
                <el-checkbox :label="30">检测机构</el-checkbox>
                <el-checkbox :label="20">消毒机构</el-checkbox>
                <el-checkbox :label="40">政府部门 </el-checkbox>
                <el-checkbox :label="50">测试</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="社会统一信用代码" prop="forms.creditUnicode">
              <el-input
                disabled
                v-model="slotForms.forms.creditUnicode"
                placeholder="社会统一信用代码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.corpCategoryList" label="企业类别">
              <dict-select
                isDisabled
                collapse-tags
                filterable
                multiple
                v-model="slotForms.forms.corpCategoryList"
                placeholder="企业类别"
                :pkey="'corp_category'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              prop="forms.corpCategoryStr"
              label="其他企业类别"
              v-if="slotForms.forms.corpCategoryStr"
              :rules="[
                {
                  required: true,
                  message: '请输入其他企业类别',
                  trigger: 'change'
                }
              ]"
            >
              <el-input
                placeholder="企业类别"
                v-model="slotForms.forms.corpCategoryStr"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="forms.corpNature" label="企业性质">
              <dict-select
                isDisabled
                v-model="slotForms.forms.corpNature"
                placeholder="企业性质"
                :pkey="'corp_nature'"
              ></dict-select>
            </el-form-item>
            <el-form-item label="企业联系电话" prop="forms.comparyTel">
              <el-input
                disabled
                v-model="slotForms.forms.comparyTel"
                placeholder="企业联系电话"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="是否城配企业" prop="forms.isCpCorp">
              <el-radio disabled v-model="slotForms.forms.isCpCorp" :label="0"
                >否</el-radio
              >
              <el-radio disabled v-model="slotForms.forms.isCpCorp" :label="1"
                >是</el-radio
              >
            </el-form-item>
            <el-form-item label="联系人姓名" prop="forms.comparyContacts">
              <el-input
                disabled
                v-model="slotForms.forms.comparyContacts"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人手机号" prop="forms.comparyContactsTel">
              <el-input
                disabled
                v-model="slotForms.forms.comparyContactsTel"
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="固定电话" prop="forms.fixedTel">
              <el-input
                disabled
                v-model="slotForms.forms.fixedTel"
                clearable
              ></el-input>
            </el-form-item> -->
            <el-form-item label="身份证号码" prop="forms.idCode">
              <el-input
                disabled
                v-model="slotForms.forms.idCode"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="forms.mainBox">
              <el-input
                disabled
                v-model="slotForms.forms.mainBox"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="所任职位" prop="forms.job">
              <el-input
                disabled
                v-model="slotForms.forms.job"
                clearable
              ></el-input>
            </el-form-item>
            <br />
            <div class="imgUpload">
              <!-- 企业logo -->
              <el-form-item
                prop="forms.logoImg"
                label="企业Logo"
                ref="uploadElement"
              >
                <el-upload
                  class="el-upload-list__item-thumbnail"
                  :class="{ hide: hideUploadLogo }"
                  action="/app/file/upload"
                  :on-preview="handlePreview"
                  :on-success="res => handleAvatarSuccess(res, 'logoImg')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'logoImg')
                  "
                  :beforeUpload="beforeAvatarUpload"
                  :file-list="fileListLogo"
                  list-type="picture-card"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <!-- 营业执照 -->
              <el-form-item
                prop="forms.businessLicPhoto"
                label="营业执照"
                ref="uploadElement"
                class="img--back"
              >
                <el-upload
                  class="el-upload-list__item-thumbnail"
                  :class="{ hide: hideUploadLicence }"
                  action="/app/file/upload"
                  :on-preview="handlePreview"
                  :on-success="
                    res => handleAvatarSuccess(res, 'businessLicPhoto')
                  "
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'businessLicPhoto')
                  "
                  :beforeUpload="beforeAvatarUpload"
                  :file-list="fileListLicence"
                  list-type="picture-card"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <!-- 资质证明 -->
              <el-form-item
                prop="forms.comparyQualifi"
                label="资质证明"
                ref="uploadElement"
                class="img--back"
                v-if="
                  formExtend.forms.comparyQualifi &&
                    formExtend.forms.comparyQualifi !== ''
                "
              >
                <el-upload
                  class="el-upload-list__item-thumbnail"
                  :class="{ hide: hideUploadCer }"
                  action="/app/file/upload"
                  :on-preview="handlePreview"
                  :on-success="
                    res => handleAvatarSuccess(res, 'comparyQualifi')
                  "
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'comparyQualifi')
                  "
                  :beforeUpload="beforeAvatarUpload"
                  :file-list="fileListCer"
                  list-type="picture-card"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过2M
                  </div>
                </el-upload>
              </el-form-item>
              <el-dialog
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
              >
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
            <br />
            <!-- <el-form-item> </el-form-item> -->
            <el-form-item
              class="remarkWidth"
              prop="forms.checkMsg"
              label="审核意见:"
              :rules="[{ validator: CheckRemarkLength, trigger: 'blur' }]"
            >
              <el-input
                type="textarea"
                :rows="3"
                v-model.number="slotForms.forms.checkMsg"
                placeholder="审核意见"
              ></el-input>
            </el-form-item>
          </template>
        </e6-form-extend>
        <!--操作-->
        <section class="operate-section">
          <el-button
            :loading="loadingState"
            type="primary"
            @click="handleSubmitForm"
            >审核通过</el-button
          >
          <el-button :loading="loadingState" @click="handleResetForm"
            >审核不通过</el-button
          >
        </section>
      </div>
    </section>

    <!-- content end -->
    <!-- 地图控件 -->
    <small-map
      ref="mapWin"
      title="地图标注"
      :optionMap="optionMap"
      :city="city"
      @showMapInfo="getMapInfo"
    ></small-map>
  </div>
</template>
``
<script>
import e6City from "e6city";
import smallMap from "@/components/smallMap/smallMap";
import {
  SaveComparyReview,
  FindBaseComparyInfoById
} from "@/api/base/customsDeclaration";
import resizeListener from "_private/mixins/resizeListener";
import { CheckRemarkLength } from "@/utils/validation";
import { FetchGetArea } from "@/api/public";
export default {
  components: { e6City, smallMap },
  mixins: [resizeListener],
  data() {
    return {
      // 地图跳转传参
      optionMap: {
        lng: "",
        lat: "",
        city: "", //选择的城市名
        level: "", //省、市、区
        location: ""
      },
      city: "", //选择的市区
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页"
          }
        },
        {
          path: "/baseComparyReviewList",
          isRedirect: true,
          meta: {
            title: "企业注册审核"
          }
        }
      ],
      formExtend: {
        forms: {
          msmNo: "",
          radio: "",
          comparyName: "",
          regisAddress: "",
          provinceName: "",
          provincId: "",
          cityName: "",
          cityId: "",
          countyName: "",
          countyId: "",
          creditUnicode: "",
          comparyType: "",
          corpNature: "",
          comparyTel: "",
          isCpCorp: "1",
          comparyContacts: "",
          comparyContactsTel: "",
          fixedTel: "",
          idCode: "",
          mainBox: "",
          job: "",
          logoImg: "",
          businessLicPhoto: "", //营业执照
          comparyQualifi: "", //资质证明
          checkMsg: "",
          regisArea: "", //注册地址省市区
          regisAreas: "",
          corpCategoryList: "",
          corpCategoryStr: "",
          userAppTypeList: [] //角色属性
        },
        extends: []
      },
      hideUploadLogo: false,
      hideUploadLicence: false,
      hideUploadCer: false,
      dialogImageUrl: "",
      dialogVisible: false,
      fileListLogo: [], //logo
      fileListLicence: [], //营业执照
      fileListCer: [], //资质证明
      provinceList: [],
      cityList: [],
      countyList: [],
      editState: false,
      CheckRemarkLength: CheckRemarkLength,
      loadingState: false,
      regisAddress: ""
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle = this.pageType === "1" ? "" : "企业注册审核";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    }
  },
  created() {
    this.FetchGetArea(0, 1, 1);
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    };
    this.breadcrumbs.push(breadcrumb);
    if (this.pageType !== "1") {
      this.FindBaseComparyInfoById({ comparyId: this.id });
      this.editState = true;
    }
  },
  methods: {
    citySelect(res) {
      if (res.province.name == "澳门") {
        this.cityName("澳门");
        this.optionMap.level = "city";
      } else if (res.province.name == "香港") {
        this.cityName("香港");
        this.optionMap.level = "city";
      } else if (res.province.name == "台湾省") {
        this.cityName("台湾省");
        this.optionMap.level = "city";
      } else {
        this.formExtend.forms.regisArea =
          res.province.name + res.city.name + res.district.name;
        this.city = res.city.name;
        this.optionMap.city = res.city.name;
        if (res.district.name === "") {
          if (res.city.name === "") {
            this.optionMap.level = "province";
          } else {
            this.optionMap.level = "city";
          }
        } else {
          this.optionMap.level = "district";
        }
      }
    },
    citysSelect(res) {
      if (res.province.name == "澳门") {
        this.cityName("澳门");
        this.optionMap.level = "city";
      } else if (res.province.name == "香港") {
        this.cityName("香港");
        this.optionMap.level = "city";
      } else if (res.province.name == "台湾省") {
        this.cityName("台湾省");
        this.optionMap.level = "city";
      } else {
        this.formExtend.forms.regisAreas =
          res.province.name + res.city.name + res.district.name;
        this.formExtend.forms.provinceName = res.province.name;
        this.formExtend.forms.cityName = res.city.name;
        this.formExtend.forms.countyName = res.district.name;
        this.city = res.city.name;
        this.optionMap.city = res.city.name;
        if (res.district.name === "") {
          if (res.city.name === "") {
            this.optionMap.level = "province";
          } else {
            this.optionMap.level = "city";
          }
        } else {
          this.optionMap.level = "district";
        }
      }
    },
    selectAddress() {
      if (!this.formExtend.forms.regisAreas.length) {
        this.$message.warning("请先选择省/市/区县");
        return;
      }
      this.optionMap.location = this.formExtend.forms.regisAddress;
      this.$refs.mapWin.showMap();
      // this.$refs.mapWin.loadQuery();
    },
    cityName(name) {
      this.formExtend.forms.regisArea = name;
      this.city = name;
      this.optionMap.city = name;
    },
    // 根据父级获取地区下拉框
    FetchGetArea(parentId, type, num) {
      FetchGetArea(parentId, type)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            if (num == 1) {
              this.provinceList = response.result;
            } else if (num == 2) {
              this.cityList = response.result;
            } else if (num == 3) {
              this.countyList = response.result;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //省选择事件
    provinceChange() {
      this.provinceList.forEach(item => {
        if (this.formExtend.forms.provinceId == item.id) {
          this.formExtend.forms.provinceName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
      this.cityList = [];
      this.countyList = [];
      this.formExtend.forms.cityName = "";
      this.formExtend.forms.countyName = "";
    },
    //市选择事件
    cityChange() {
      this.cityList.forEach(item => {
        if (this.formExtend.forms.cityId == item.id) {
          this.formExtend.forms.cityName = item.name;
          return;
        }
      });
      this.FetchGetArea(this.formExtend.forms.cityId, 3, 3);
      this.coutyList = [];
      this.formExtend.forms.countyName = "";
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpg";
      const extension2 = testmsg === "png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是 jpg、png格式!",
          type: "warning"
        });
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "warning"
        });
      }
      return extension || (extension2 && isLt2M);
    },
    handleRemove() {
      // DeleteFile({ fileName: this.formExtend.forms.logoImg })
      // this.formExtend.forms.logoImg = ''
      // this.hideUpload = fileList.length >= 1
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, type) {
      if (type === "logoImg") {
        this.formExtend.forms.logoImg = res.result.filename;
      } else if (type === "businessLicPhoto") {
        this.formExtend.forms.businessLicPhoto = res.result.filename;
      } else if (type === "comparyQualifi") {
        this.formExtend.forms.comparyQualifi = res.result.filename;
      }
    },
    handleChange(file, fileList, type) {
      if (type === "logoImg") {
        this.hideUploadLogo = fileList.length >= 1;
      } else if (type === "businessLicPhoto") {
        this.hideUploadLicence = fileList.length >= 1;
      } else if (type === "comparyQualifi") {
        this.hideUploadCer = fileList.length >= 1;
      }
    },
    // 获取企业审核数据
    FindBaseComparyInfoById(response) {
      FindBaseComparyInfoById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result);
          console.log(this.formExtend.forms.provinceName);
          if (this.formExtend.forms.provinceName) {
            this.provinceList.forEach(item => {
              if (this.formExtend.forms.provinceName == item.name) {
                this.formExtend.forms.provinceId = item.id;
                return;
              }
            });
            this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
            this.formExtend.forms.regisAreas =
              this.formExtend.forms.provinceName +
              this.formExtend.forms.cityName +
              this.formExtend.forms.countyName;
            this.optionMap.city = this.formExtend.forms.cityName;
            this.city = this.formExtend.forms.cityName;
          }
          if (response.result.cityId) {
            this.FetchGetArea(response.result.cityId, 3, 3);
          }
          this.fileListLogo = [{ url: response.result.logoImg }];
          this.hideUploadLogo = this.fileListLogo.length >= 1;
          this.fileListLicence = [{ url: response.result.businessLicPhoto }];
          this.hideUploadLicence = this.fileListLicence.length >= 1;
          this.fileListCer = [{ url: response.result.comparyQualifi }];
          this.hideUploadCer = this.fileListCer.length >= 1;
        })
        .catch(error => {
          console.log(error);
        });
    },

    // 企业审核
    SaveComparyReview(response) {
      SaveComparyReview(response)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 审核完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseComparyReviewList",
              query: { refreshportion: true }
            });
          }
          this.loadingState = false;
        }
      });
    },
    // 提交
    handleSubmitForm() {
      if (this.formExtend.forms.checkMsg.toString().length <= 100) {
        this.loadingState = true;
        this.SaveComparyReview({
          comparyId: this.id,
          corpState: 2,
          checkMsg: this.formExtend.forms.checkMsg
        });
      }
    },
    // 取消
    handleResetForm() {
      if (this.formExtend.forms.checkMsg) {
        if (this.formExtend.forms.checkMsg.toString().length <= 100) {
          this.loadingState = true;
          this.SaveComparyReview({
            comparyId: this.id,
            corpState: 3,
            checkMsg: this.formExtend.forms.checkMsg
          });
        }
      } else {
        this.$message({
          message: "请填写审核意见",
          type: "warning"
        });
      }
    },
    // 地图标注回调
    getMapInfo(data) {
      this.formExtend.forms.regisAddress = data.location;
      this.formExtend.forms.lon = data.lng;
      this.formExtend.forms.lat = data.lat;
      this.regisAddress = data.location;
    }
  }
};
</script>

<style lang="scss" scoped>
.remarkWidth {
  width: 70%;
}
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
    box-sizing: border-box;
    height: 100%;
    overflow: auto;
    .group_form {
      width: 50%;
      display: inline-block;
      vertical-align: top;
      .el-form-item {
        width: auto;
        .e6-city {
          width: 178px;
          /deep/ .city-input {
            width: 100% !important;
          }
        }
        &:last-child {
          width: calc(100% - 398px);
          max-width: 300px;
          /deep/.el-form-item__content {
            width: 100%;
            .el-button {
              width: 100%;
              &.show_tips::before {
                content: "在地图上标注";
                color: #898c91;
                position: absolute;
              }
              span {
                display: inline-block;
                width: calc(100% - 20px);
                overflow: hidden;
                text-overflow: ellipsis;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
}
.operate-section {
  margin: 0 10px;
  text-align: center;
  background: #fff;
  position: relative;
  top: 14%;
  .el-button {
    padding: 10px 36px;
    font-size: 14px;
  }
}

/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 500px;
  }
}

.el-form {
  .item--recommon {
    margin-left: 5px;
    display: inline-block;
    color: #898c91;
    // position: absolute;
  }
  .imgUpload {
    width: auto;
    .el-form-item--mini {
      width: auto;
    }
  }
  .img--back {
    /deep/ .el-form-item__label {
      width: 100px !important;
    }
  }
}
</style>
